import {pick} from "lodash";
import moment from "moment";
import {DATE_TIME_FORMAT} from "../../../constants/define"
import {formatInt, removeObjectNullFull} from "../../../utils/functions";

export default class SubscriptionTransactionRequest {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data?.id || "";
        this.tracker = data?.tracker.toString();
    }

    exportUpdate() {
        return {
            id: this.id,
            tracker: this.tracker,
        }
    }

}

export const common = {
    ACTION_FIELD: {},
}

export const filtersParams = (filters) => {
    return Object.keys(filters).length > 0 ? removeObjectNullFull({
        status: filters?.status === 0 ? 0 : filters?.status || "",
        type: filters?.type || "",
        subscription_type: filters?.subscription_type || "",
        month: filters?.month ? moment(filters?.month).format("YYYYMM") : undefined,
        search: filters?.search || "",
        is_export: filters?.is_export || "",
        page_size: filters?.page_size || 10,
        page_index: filters?.page_index || 1,
        order_field: filters?.order_field || "",
        order_value: filters?.order_value || "",
    }) : {}
}

